<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Je Komponenteninstanz: Timer, Anfragezähler und Geocoder
    this.timer = null;
    this.requestId = 0;
    this.pendingQuery = null;
    this.geocoder = null;
    this.destroyed = false;

    GeocoderFactory().then(geocoder => {
      if (this.destroyed) {
        return;
      }

      this.geocoder = geocoder;

      if (this.pendingQuery != null) {
        const query = this.pendingQuery;
        this.pendingQuery = null;
        this.querySelections(query);
      }
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.cancelPending();
  },

  watch: {
    search(val) {
      if (!val || !String(val).trim()) {
        this.cancelPending();
        this.items = [];
        return;
      }

      if (this.select && typeof this.select === "object" && val === this.select.text) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // Beendet Timer und laufende Anfrage; spätere Antworten werden verworfen.
    cancelPending() {
      this.requestId++;

      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.pendingQuery = null;

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.cancelPending();

      const requestId = this.requestId;
      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        if (!this.geocoder) {
          this.pendingQuery = value;
          return;
        }

        this.geocoder.autocomplete(value).then(items => {
          if (requestId !== this.requestId || items === null) {
            return;
          }

          this.items = items.slice();
        }).catch(() => {
          if (requestId === this.requestId) {
            this.items = [];
          }
        }).finally(() => {
          if (requestId === this.requestId) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.cancelPending();
      this.$emit("change", o);
    }
  }
};
</script>
